import { useRouter } from "next/router"

const Error = () => {
    const router = useRouter()
    router.push("/login")
    return <>
    </>
}
export default Error